<div class="container-custom">
  <div class="row align-items-center justify-content-center">
    <div style="width: 100%">

    <form #Form="ngForm" (ngSubmit)="onSubmit()" autocomplete="off" validate>
        <div class="card w-100">
            <div class="card-header">{{'SUBMENU.ACTIVATOR_AUDIT_LOGS' | translate}} - {{'COUNTRY_AUDIT_LOGS.FILTERS' | translate}}</div>
            <div class="card-body">
                <div class="row align-items-end">
                    <div class="col-md-3">
                        <label>{{'ADMIN.SINCE' | translate}}</label>
                        <input type="datetime-local"
                               name="dateFrom"
                               required
                               [(ngModel)]="dateFrom"
                               class="form-control w-100">
                        <small class="text-danger text-danger-custom" [class.d-none]="dateFrom.includes('-')">{{'COM.FIELD'| translate}} {{'COM.REQUIRED'| translate}}</small>
                        <div class="spacer-custom-100"></div>
                    </div>
                    <div class="col-md-3">
                        <label>{{'ADMIN.UNTIL' | translate}}</label>
                        <input type="datetime-local"
                               name="dateSince"
                               required
                               [(ngModel)]="dateSince"
                               class="form-control w-100">
                        <small class="text-danger text-danger-custom" [class.d-none]="dateSince.includes('-')">{{'COM.FIELD'| translate}} {{'COM.REQUIRED'| translate}}</small>
                        <div class="spacer-custom-100"></div>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-custom" style="min-width: 100px" type="submit" [disabled]="Form.invalid">{{'COM.SEARCH' | translate}}</button>
                        &nbsp;
                        <button class="btn btn-outline-custom" type="button" (click)="resetForm(Form)">{{'COUNTRY_AUDIT_LOGS.CLEAN_FIELDS' | translate}}</button>
                        &nbsp;
                        <button class="btn btn-custom" type="button" (click)="ExportAudit()" [disabled]="!hasResult" style="min-width: 100px">{{'ADMIN.EXPORT' | translate }}</button>
                        <div class="spacer-custom-100"></div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div style="width: 100%; height: 20px;"></div>

    <div style="display: none;" name="grid" id="grid">
        <div class="card w-100">
            <div class="card-header">{{'COUNTRY_AUDIT_LOGS.RESULT' | translate}}</div>
            <div class="card-body">
                <mat-table matSort [dataSource]="dataSourceAuditActivator" #Sort="matSort">

                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="justify-content-center align-items-center font-size-custom padding-left">id</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="justify-content-center align-items-center font-size-custom">{{element.id}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="source">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="justify-content-center align-items-center font-size-custom">source</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="justify-content-center align-items-center font-size-custom">{{element.source}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="justify-content-center align-items-center font-size-custom">action</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="justify-content-center align-items-center font-size-custom">{{element.action}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="detail">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="justify-content-center align-items-center font-size-custom">detail</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="justify-content-center align-items-center font-size-custom">{{element.detail}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="result">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="justify-content-center align-items-center font-size-custom">result</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="justify-content-center align-items-center font-size-custom">{{element.result}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="usr">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="justify-content-center align-items-center font-size-custom">usr</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="justify-content-center align-items-center font-size-custom">{{element.usr}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="datetime">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="justify-content-center align-items-center font-size-custom">datetime</mat-header-cell>
                        <mat-cell *matCellDef="let element" class="justify-content-center align-items-center font-size-custom">{{element.datetime}}</mat-cell>
                    </ng-container>

                    <mat-header-row style="min-width: 1200px; width: 100%;" *matHeaderRowDef="displayedColumnsAudit"></mat-header-row>
                    <mat-row style="min-width: 1200px; width: 100%;" *matRowDef="let row; columns: displayedColumnsAudit;" (click)="selectAuditActivatorRow(row.id)" [ngClass]="{'highlight-table-custom': selectedRowIndex == row.id}" class="mat-row"></mat-row>
                </mat-table>
                <mat-card *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center">
                    <mat-card-content>
                        <p></p>
                        <p>{{'COUNTRY.LOADING' | translate}}...</p>
                    </mat-card-content>
                </mat-card>
                <mat-paginator #Paginator="matPaginator" [pageSizeOptions]=" [5, 10, 15, 25, 50, 100]" [pageSize]="100" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>

</div>
</div>
</div>
